module.exports = __webpack_public_path__ + "static/media/empty-search-results.7a1b613f.svg";